import { Group, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

type CreateClientFormValues = {
  firstName: string;
  middleName?: string;
  lastName: string;
  emailAddress: string | null | undefined;
  advised: boolean;
};

interface Props<T extends CreateClientFormValues> {
  form: UseFormReturnType<T>;
}

export default function CreateClientForm<T extends CreateClientFormValues>({ form }: Props<T>) {
  return (
    <>
      <Group grow align="flex-start">
        <TextInput label="First name" placeholder="Jane" {...form.getInputProps('firstName')} />
        <TextInput label="Last name" placeholder="Doe" {...form.getInputProps('lastName')} />
      </Group>

      <TextInput label="Middle name" placeholder="Robert" {...form.getInputProps('middleName')} />

      <TextInput
        label="Email"
        placeholder="Client email address"
        {...form.getInputProps('emailAddress')}
      />
    </>
  );
}
